import { Button } from "../Button/Button";
import { Icon } from "../Icon/Icon";

export default function FigmaAuth({ onClick, isLoading, state }) {
    return <Button
        label="Connect Figma"
        type={isLoading ? "primary" : "secondary"}
        size="medium"
        iconLeft={<Icon value="sync" size={"small"} />}
        onClick={() => {
            onClick();
        }}
        microLoading={isLoading}
        state={state}
    />;
}

var figma_login_window;
let browser = window;
let timer = null;

function watcher() {
    if (figma_login_window === null) {
        clearInterval(timer);
        timer = null;
    } else if (figma_login_window !== null && !figma_login_window.closed) {
        figma_login_window.focus();
    } else if (figma_login_window !== null && figma_login_window.closed) {
        clearInterval(timer);
        browser.focus();
        timer = null;
        figma_login_window = null;
    }
}

export const openFigmaAuthWindow = (callback) => {
    const w = 600;
    const h = 600;
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;

    figma_login_window = window.open(
        "https://www.figma.com/oauth?client_id=fvYB9GwDlD3qnJemZc04vn&redirect_uri=" + process.env.REACT_APP_URL + "figma/login&scope=file_content:read%20file_metadata:read&state=login&response_type=code",
        "figma_login_window",
        "width=600,height=600,top=" + top + ",left=" + left
    );

    if (timer === null) {
        timer = setInterval(watcher, 500);
    }

    const bc = new BroadcastChannel("figma_channel");

    bc.onmessage = (event) => {
        let params = new URLSearchParams(event.data);
        callback(params.get("state"), params.get("code"));
        figma_login_window.close();
        bc.close();
    };
}
